import {
  Box,
  FormControlLabel,
  makeStyles,
  Paper,
  Radio,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
  withStyles,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { isArray } from "lodash";
import CheckIcon from "@material-ui/icons/Check";
import MuiAlert from "@material-ui/lab/Alert";

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "rgb(0, 97, 129)",
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableBodyCell = withStyles((theme) => ({
  head: {
    backgroundColor: "rgb(0, 97, 129)",
    color: theme.palette.common.white,
    verticalAlign: "top",
  },
  body: {
    fontSize: 14,
    verticalAlign: "top",
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

const useStyles = makeStyles({
  table: {},
  tableContainer: {
    maxHeight: "40vh",
    overflowY: "auto",
  },
});

function NameRow({ row }) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box>
        <Typography component={"span"} variant="h6">
          {row?.name}
        </Typography>
      </Box>
    </Box>
  );
}

function AvailableAssessmentsTable({
  assessments,
  selectedAssessment,
  setSelectedAssessment,
}) {
  const classes = useStyles();

  const handleAssessmentChange = (event) => {
    const selected = assessments.find((s) => s.id === event.target.value);
    setSelectedAssessment(selected);
  };

  return (
    <>
      <TableContainer component={Paper} className={classes.tableContainer}>
        <Table
          size="small"
          className={classes.table}
          aria-label="Assessments table"
          stickyHeader
        >
          <TableHead>
            <TableRow>
              <StyledTableCell>Name</StyledTableCell>
              <StyledTableCell></StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {assessments.map((row) => (
              <StyledTableRow key={row?.id}>
                <StyledTableBodyCell component="th" scope="row">
                  {row?.name ? <NameRow row={row} /> : null}
                </StyledTableBodyCell>

                <StyledTableBodyCell>
                  {row?.id ? (
                    <FormControlLabel
                      value={row.id}
                      control={<Radio />}
                      checked={row.id === selectedAssessment?.id}
                      onChange={handleAssessmentChange}
                      label=""
                    />
                  ) : null}
                </StyledTableBodyCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}

AvailableAssessmentsTable.propTypes = {
  assessments: PropTypes.array.isRequired,
  selectedAssessment: PropTypes.object,
  setSelectedAssessment: PropTypes.func.isRequired,
};

export default AvailableAssessmentsTable;
